// extracted by mini-css-extract-plugin
export default {"statisticsStats":"sPuYomHhISwv2DJO5mKU"};